const rooster = {
  conversationsList: {
    width: '296px',
    overflowY: 'auto',
    position: 'relative',
  },
  noConvosMsg: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    fontSize: '18px',
  },
  conversationLoaderBox: {
    position: 'relative',
    height: '60px',
    width: '100%',
  },
  conversationWaypoint: {
    position: 'relative',
    bottom: '5px',
  },
}

const tops = {
  conversationsList: {
    width: '299px',
    overflowY: 'auto',
    position: 'relative',
    padding: 0,
  },
  noConvosMsg: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    fontSize: '18px',
  },
  conversationLoaderBox: {
    position: 'relative',
    height: '60px',
    width: '100%',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/ConversationsList.js